import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const cityApi = createApi({
  reducerPath: 'cityApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/cities' }),
  endpoints: (builder) => ({
    getCities: builder.query({
      query: (searchParams = '') => `?${searchParams}`,
      transformResponse: (response) => response.cities
    })
  })
})

const { useGetCitiesQuery } = cityApi

export {
  cityApi,
  useGetCitiesQuery
}
